export enum FileState {
  New = 'new',
  Delete = 'delete',
  Keep = 'keep',
}
